import { type Role, RoleAccessMatrix } from './roledescription/RoleAccessMatrix.ts';
import { RoleDescription } from './roledescription/RoleDescriptionDetails';
import { RoleDescriptionTable } from './roledescription/RoleDescriptionTable';
import { useState } from 'react';

export const UserGroupRolesExplanation = () => {
    const [selectedRole, setSelectedRole] = useState<Role | null>(null);

    if (selectedRole) {
        return <RoleDescription role={RoleAccessMatrix[selectedRole]} switchToOverview={() => setSelectedRole(null)} />;
    } else {
        return <RoleDescriptionTable fullContent={RoleAccessMatrix} switchRoleFn={role => setSelectedRole(role)} />;
    }
};
